import $ from 'jquery'
import '../scss/module_category.scss';

import Collapse from 'bootstrap/js/dist/collapse'
import Modal from 'bootstrap/js/dist/modal'
import Dropdown from 'bootstrap/js/dist/dropdown'

import {doLast} from './module_last';
import { initFirebaseApp } from './module_firebase';
import { manageLogin } from './module_auth_helper';

import {funnelUpdateWhenAvailable, funnelUpdate, attachTryPremiumSubscribe} from './module_common';
import {setSearchOrder} from './module_api_search';

import {attachShowNextPageListener} from './module_pagination';

import {setCategoriesLike} from './module_api_call';

import {attachToggleActionButton} from './module_toggle-button';

import {configBookCard} from './module_book_card';

import {attachCtaActions} from './module_actions';

import { initCardLazyLoad } from './module_lazyload';

import './module_common_actions';

import { initNavbar } from './module_header';
import { initSentry } from './module_sentry';

function manageCategoryFavourite(catId, action){
    let data = []
    if (action === 'remove'){
        data.push({id: catId, val: false})
    }else{
        data.push({id: catId, val: true})
    }
    return setCategoriesLike(data)
    .then(resp => {
        if (resp.data[0].ok && resp.data[0].liked == 1 ){
            funnelUpdate("category_liked")
        }
        return resp
    })
}

document.addEventListener("DOMContentLoaded", () => {
    initSentry()
    initFirebaseApp()
    manageLogin()

    attachTryPremiumSubscribe()
    
    doLast()
    initCardLazyLoad()
    initNavbar()
    
    if (!isPageReloadedAfterLogin) funnelUpdateWhenAvailable('category_viewed');

    configBookCard()
    attachToggleActionButton(manageCategoryFavourite)

    attachCtaActions()

    setSearchOrder('server_default')

    attachShowNextPageListener()
});